/* eslint-disable */
import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'
import routes from './combined.routes'

Vue.use(Meta)
Vue.use(Router)

// The middleware for every page of the application.
const globalMiddleware = ['check-auth']

// Load middleware modules dynamically.
const routeMiddleware = resolveMiddleware(
  require.context('@/router/middleware', false, /.*\.js$/)
)

const router = createRouter()

// sync(store, router)

export default router

// function reCreateRoutesBaseOnUserRole(oldRoutes) {
//   return oldRoutes.filter(route => {
//     const role = store.getters['auth/user']?.role
//     if (role) {
//       return [role, 'shared'].includes(route.authorizedRole)
//     }
//     return ['shared'].includes(route.authorizedRole)
//   })
// }

/**
 * Create a new router instance.
 *
 * @return {Router}
 */
function createRouter() {
  const initialRouter = new Router({
    scrollBehavior,
    mode: 'history',
    routes,
  })

  initialRouter.beforeEach(beforeEach)
  initialRouter.afterEach(afterEach)

  return initialRouter
}

let modals = []

router.onReady(() => {
  try {
    router.app.$root.$on('bv::modal::show', (_event, modal) => {
      if (!modals.includes(modal)) {
        modals.push(modal)
      }
    })

    router.app.$root.$on('bv::modal::hide', (_event, modal) => {
      if (modals.includes(modal)) {
        modals = modals.filter(id => id !== modal)
      }
    })
  } catch {
    // Do nothing
  }
})

/**
 * Global router guard.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
async function beforeEach(to, from, next) {
  // router.options.routes = await reCreateRoutesBaseOnUserRole(routes)
  // ? For splash screen
  // Remove afterEach hook if you are not using splash screen
  // router.afterEach(async () => {
  // router.options.routes = await reCreateRoutesBaseOnUserRole(routes)
  // Remove initial loading
  /*
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
      appLoading.style.display = 'none'
    }*/
  // })
  // const user = store.getters['auth/user']?.id
  // if (!user && to.name !== 'shared.login') {
  //   next({ name: 'shared.login' })
  // }
  // if (modals.length > 0 && misc.methods.isMobile()) {
  //   return next(false)
  // }

  if (to?.meta) {
    if (to.meta?.breadcrumb && Array.isArray(to.meta.breadcrumb)) {
      to.meta.breadcrumb = Array.from(to.meta.breadcrumb).map(
        breadcrumb => {
          if (breadcrumb?.to) {
            if (breadcrumb.to?.useParameters) {
              return Object.assign(breadcrumb, {
                to: {
                  ...breadcrumb.to,
                  params: to.params
                }
              })
            }
          }
          return breadcrumb
        }
      )
    }
  }

  let components = []

  try {
    // Get the matched components and resolve them.
    components = await resolveComponents(
      router.getMatchedComponents({
        ...to,
      })
    )
  } catch (error) {
    if (/^Loading( CSS)? chunk (\d)+ failed\./.test(error.message)) {
      window.location.reload(true)
      return
    }
  }

  if (components.length === 0) {
    return next()
  }

  // Start the loading bar.
  if (components[components.length - 1].loading !== false) {
    router.app.$nextTick(() => router.app.$insProgress.start())
  }

  // Get the middleware for all the matched components.
  /* eslint no-use-before-define: ["error", { "functions": false }] */
  const middleware = getMiddleware(components)

  // Call each middleware.
  callMiddleware(middleware, to, from, (...args) => {
    // Set the application layout only if "next()" was called with no args.
    // if (args.length === 0) {
    //   router.app.setLayout(components[0].layout || '')
    // }

    next(...args)
  })
}

/**
 * Global after hook.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
async function afterEach(to, from, next) {
  await router.app.$nextTick().then(() => {
    router.app.$insProgress.finish()
  })
}

/**
 * Call each middleware.
 *
 * @param {Array} middleware
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
function callMiddleware(middleware, to, from, next) {
  const stack = middleware.reverse()

  const _next = (...args) => {
    // Stop if "_next" was called with an argument or the stack is empty.
    if (args.length > 0 || stack.length === 0) {
      if (args.length > 0) {
        router.app.$insProgress.finish()
      }

      return next(...args)
    }

    const middleware = stack.pop()

    if (typeof middleware === 'function') {
      middleware(to, from, _next)
    } else if (routeMiddleware[middleware]) {
      routeMiddleware[middleware](to, from, _next)
    } else {
      throw Error(`Undefined middleware [${middleware}]`)
    }
  }

  _next()
}

/**
 * Resolve async components.
 *
 * @param  {Array} components
 * @return {Array}
 */
function resolveComponents(components) {
  return Promise.all(
    components.map((component) =>
      typeof component === 'function' ? component() : component
    )
  )
}

/**
 * Merge the the global middleware with the components middleware.
 *
 * @param  {Array} components
 * @return {Array}
 */
function getMiddleware(components) {
  const middleware = [...globalMiddleware]

  components
    .filter((c) => c.middleware)
    .forEach((component) => {
      if (Array.isArray(component.middleware)) {
        middleware.push(...component.middleware)
      } else {
        middleware.push(component.middleware)
      }
    })

  return middleware
}

/**
 * Scroll Behavior
 *
 * @link https://router.vuejs.org/en/advanced/scroll-behavior.html
 *
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  }

  if (to.hash) {
    return { selector: to.hash }
  }

  const [component] = router.getMatchedComponents({ ...to }).slice(-1)

  if (component && component.scrollToTop === false) {
    return {}
  }

  return { x: 0, y: 0 }
}

/**
 * @param  {Object} requireContext
 * @return {Object}
 */
function resolveMiddleware(requireContext) {
  return requireContext
    .keys()
    .map((file) => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
    .reduce(
      (guards, [name, guard]) => ({ ...guards, [name]: guard.default }),
      {}
    )
}
